<script setup lang="ts">
import RecentElementals from '../../components/RecentElementals/index.vue'
import ElementalsListControls from '../../components/ElementalsListControls/index.vue'
import FavoriteElementals from '../../components/FavoriteElementals/index.vue'
import UnauthEmptyState from './UnauthEmptyState.vue'
import Library from '~~/src/components/Library/index.vue'
import { useLibraryTableFilter } from '~~/src/components/Library/TableLibrary/composables/useTableFilter'
import KMSElementals from '@/components/DrawerSidebarRight/components/KMSElementals/index.vue'

defineOptions({
  name: 'DrawerSidebarDrawerElementalLists',
})
const {
  separatedByType,
  filterByMe,
} = useLibraryTableFilter({
  separatedByType: true,
  filterByMe: false,
  savedMode: false,
})

const user = useUser()
</script>

<template>
  <div
    v-if="user"
    class="flex flex-col max-h-full w-full no-scrollbar"
  >
    <div
      class="w-full sticky top-0 left-0 z-30 border-gray2 border-b pb-3 bg-white"
    >
      <div
        class="py-0 z-10 w-full bg-gradient-to-b from-white via-white-75% to-transparent"
        :class="
          $style['no-scrollbar']
        "
        overflow-x-auto
      >
        <ElementalsListControls />
      </div>
    </div>
    <div class="flex flex-col pb-4 no-scrollbar">
      <Library
        :separated-by-type="separatedByType"
        :hide-filters="true"
        :filter-by-me="filterByMe"
      >
        <template #recent-elementals>
          <KMSElementals />
          <FavoriteElementals />
          <RecentElementals />
        </template>
      </Library>
    </div>
  </div>
  <UnauthEmptyState v-else />
</template>

<style module lang="scss">
 .no-scrollbar{
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
    width: 0px;
    background: transparent;
  }
 }
</style>
